import { ICloudStorageProvider } from "../../domain/Upload/i-cloud-storage-provider";
import { HttpService } from "../http/http";
import { HttpClient } from "@angular/common/http";
import { Auth } from "../auth";
import { TenantStorageOption } from "../../domain/tenant-storage-option";
import { IUploadFile } from "../../domain/Upload/i-upload-file";
import { OvhUploadFile } from "./ovh-upload-file";
import { OracleOciUploadFile } from "./oracle-oci-upload-file";

export class OracleObjectStorageProvider implements ICloudStorageProvider {
  constructor(
    private _http: HttpService,
    private _httpClient: HttpClient,
    private _auth: Auth,
  ) {}
  createFile(
    id: string,
    file: File,
    fileName: string,
    uploadType:
      | "originalMediaContent"
      | "mediaContent"
      | "thumbnail"
      | "graphics"
      | "graphicsThumbnails"
      | "graphicsFont"
      | "graphicsSampleVideo",
    notifyServer: (objectKey: string) => Promise<any>,
    customData?: any,
  ): IUploadFile {
    return new OracleOciUploadFile(
      id,
      file,
      uploadType,
      customData,
      notifyServer,
      new Date(),
      this._httpClient,
      this._http,
      this._auth,
    );
  }

  createFileForTenantBucket(
    id: string,
    file: File,
    s3Filename: string,
    tenantStorageOption: TenantStorageOption,
  ): Promise<IUploadFile> {
    return Promise.resolve(undefined);
  }

  createOriginalMediaFile(
    id: string,
    file: File,
    fileName: string,
    notifyServer: (objectKey: string) => Promise<any>,
    customData?: any,
  ): IUploadFile {
    return new OracleOciUploadFile(
      id,
      file,
      "originalMediaContent",
      customData,
      notifyServer,
      new Date(),
      this._httpClient,
      this._http,
      this._auth,
    );
  }

  createTranscodedFile(
    id: string,
    file: File,
    fileName: string,
    notifyServer: (objectKey: string) => Promise<any>,
    customData?: any,
  ): IUploadFile {
    throw new Error(
      "OracleObjectStorageProvider -> createTranscodedFile is not supported yet.",
    );
  }

  init(): Promise<void> {
    return Promise.resolve(undefined);
  }

  isCustomServiceUrl(): boolean {
    return false;
  }
}
